import { createFileRoute, redirect } from "@tanstack/react-router";

import { APP_ROUTES_FULL, APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_FULL.EVENT_BOOKINGS)({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: APP_ROUTES_TO.EVENT_SLOTS,
            params: { id: params.id },
            replace: true,
        });
    },
    component: () => null,
});
